import React from "react";
import ReactDOM from "react-dom";
import "./index.css";
import App from "./App";
import reportWebVitals from "./reportWebVitals";
import { url } from "./settings";
import {
  authHeaders,
  exchangeCodeFromUrl,
  getRefreshToken,
  refreshTokens,
} from "./auth";

// Dependencies
import { BrowserRouter } from "react-router-dom";

// Apollo
import {
  ApolloProvider,
  InMemoryCache,
  ApolloClient,
  HttpLink,
  from,
  fromPromise,
} from "@apollo/client";
import { setContext } from "@apollo/client/link/context";
import { onError } from "@apollo/client/link/error";

// Bearer token on every request (see auth.js). `credentials: "include"` stays
// for the transition: a user signed in with the old session cookie keeps
// working until they next sign in on medzcool.com and arrive with a code.
const httpLink = new HttpLink({ uri: `${url}/graphql/`, credentials: "include" });

const authLink = setContext((_, { headers }) => ({
  headers: authHeaders(headers),
}));

// The API answers 401 when the access token has expired: refresh once and
// replay the request with the new token.
const refreshLink = onError(({ networkError, operation, forward }) => {
  if (networkError && networkError.statusCode === 401 && getRefreshToken()) {
    return fromPromise(refreshTokens()).flatMap((refreshed) => {
      if (!refreshed) throw networkError;
      operation.setContext(({ headers = {} }) => ({ headers: authHeaders(headers) }));
      return forward(operation);
    });
  }
});

const client = new ApolloClient({
  cache: new InMemoryCache(),
  link: from([authLink, refreshLink, httpLink]),
  resolvers: {},
});

// Turn a `?code=` from medzcool.com into tokens before the first query runs.
exchangeCodeFromUrl().then(() => {
  ReactDOM.render(
    <ApolloProvider client={client}>
      <BrowserRouter>
        <React.StrictMode>
          <App />
        </React.StrictMode>
      </BrowserRouter>
    </ApolloProvider>,
    document.getElementById("root")
  );
});

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
